import React, { useState, useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { InputLabel, Paper, Grid, Button, Select, MenuItem } from '@material-ui/core'
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos'
import serviceAdmin from '../../services/serviceAdmin'
import { tabsStyle } from '../../classes'
import TextAreaField from '../StyledComponent/TextAreaField'
import CssTextField from '../StyledComponent/CssTextField'
import useColor from '../../context/themeContext'



const TabNewCategory = (props) => {
    const { COLORS } = useColor();
    const useStyles = makeStyles({
        ...tabsStyle(COLORS),
        arrow: {
            width: "100%",
            height: "48px",
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            cursor: "pointer"
        },
        arrowicon: {
            color: "#999"
        }
    });
    const classes = useStyles();


    const [input, setInput] = useState({})
    const [categories, setCategories] = useState([])

    let slugRegex = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;

    const handleChange = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        setInput({ ...input, [name]: value })
    }

    function clean(obj) {
        for (let propName in obj) {
            if (obj[propName] === "" || obj[propName] === undefined) {
                delete obj[propName];
            }
        }
    }

    useEffect(() => {

        serviceAdmin.getService("v1/course-categories/parents/")
            .then(res => {
                if (res.status === 200) {
                    setCategories(res.data.data)
                }
            }).catch(err => {
                console.log(err)
            })
    }, [])


    const createCategory = () => {
        clean(input);

        serviceAdmin.postService("v1/course-categories/", input)
            .then(res => {
                if (res.status === 201) {
                    props.setCustomAlert(true, "success", "Categoria creata correttamente!")
                    props.setReload();
                    props.handleClose();
                }
            }).catch(err => {
                console.log(err)
            })
    }

    return (
        <React.Fragment>
            <Paper className={classes.root}>
                <div className={classes.arrow} onClick={props.handleClose}>
                    <ArrowBackIosIcon className={classes.arrowicon} />
                </div>
                <div className={classes.content}>
                    <h2 className={classes.title}>Crea una nuova categoria</h2>
                    <div style={{ paddingTop: "20px" }}>
                        <Grid container spacing={3}>
                            <Grid spacing={3} container item xs={12} lg={6}>

                                <Grid className="flex-center" item xs={12} md={6}>
                                    <InputLabel className={classes.label}>
                                        Nome*
                                    </InputLabel>
                                    <CssTextField name="name" value={input.name || ""} onChange={handleChange} placeholder="Nome della categoria" variant="outlined" inputProps={{ className: classes.input }} />
                                </Grid>
                                <Grid className="flex-center" item xs={12} md={6}>
                                    <InputLabel className={classes.label}>
                                        Slug
                                    </InputLabel>
                                    <CssTextField name="slug" value={input.slug || ""} onChange={handleChange} placeholder="Slug della categoria" variant="outlined" inputProps={{ className: classes.input }} />
                                </Grid>

                                <Grid className="flex-center" item xs={12} md={6}>

                                    <InputLabel className={classes.label}>
                                        Categoria genitore
                                    </InputLabel>
                                    <Select name="parent_id" value={input.parent_id || ""} onChange={handleChange} variant="outlined" className={classes.select}>
                                        <MenuItem className={classes.selected} value="">Nessuna categoria</MenuItem>
                                        {
                                            categories.length > 0 ?
                                                categories.map((category, index) => {
                                                    return (
                                                        <MenuItem className={classes.selected} key={index} value={category.id}>{category.name}</MenuItem>
                                                    )
                                                })
                                                : null
                                        }

                                    </Select>

                                </Grid>


                                <Grid className="flex-center" item xs={12} style={{ paddingTop: "20px" }}>
                                    <InputLabel className={classes.label}>
                                        Descrizione
                                    </InputLabel>
                                    <TextAreaField name="description" value={input.description || ""} onChange={handleChange} placeholder="Descrizione della categoria" multiline rows={5} variant="outlined" inputProps={{ className: classes.textarea }} />
                                </Grid>

                            </Grid>

                        </Grid>
                    </div>

                    <div className={classes.container_btn}>
                        <Button onClick={props.handleClose} className={classes.btn_del}>Annulla</Button>
                        <Button disabled={(slugRegex.test(input.slug) || input.sluig === "") && input.name ? false : true} onClick={createCategory} className={classes.btn_save}>Crea</Button>
                    </div>
                </div>
            </Paper>
        </React.Fragment>
    )
}

export default TabNewCategory;